import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';


export default function PrintGroups({groups}) {
  const { t } = useTranslation();


  useEffect(() => { // Handle print
    const beforePrint = () => document.getElementById('print').style.display = 'block';
    const afterPrint = () => document.getElementById('print').style.display = 'none';

    window.addEventListener('beforeprint', beforePrint);
    window.addEventListener('afterprint', afterPrint);

    return () => {
      window.removeEventListener('beforeprint', beforePrint);
      window.removeEventListener('afterprint', afterPrint);
    };
  }, []);


  return (
    <div id="print">
      <table id="print__header">
        <thead>
          <tr>
            <th id="print__logo">
              <img src="/assets/images/logo.png" alt="Logo"/>
              <p style={{display: 'none' /* used as brand name in excel file */}}>SoftThinks</p>
            </th>
            <th style={{fontSize: '24px', fontWeight: '600'}}>{t('global.dashboard')}</th>
          </tr>
          {/* Spacing */}<tr/><tr/>
        </thead>

        <tbody style={{fontWeight: '600'}}>
          <tr>
            <td>{t('admin.groups.print.header', {s: groups.length > 1 ? 's' : ''})}</td>
            <td>{groups.length}</td>
          </tr>
          {/* Spacing */}<tr/><tr/><tr/>
        </tbody>
      </table>

      <table id="print__content">
        <thead>
          <tr>
            <th style={{width: '600px'}}>{t('admin.groups.print.content.name')}</th>
            <th className="separation"/>

            <th style={{width: '300px'}}>{t('admin.groups.print.content.management')}</th>
          </tr>
        </thead>

        <tbody>
          {groups.map(group => (
            <tr style={{margin: '10px 0'}} key={group.id}>
              <td>{group.name}</td>
              <td className="separation"/>

              <td>{group.management}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}